import React from 'react'
import {
  useGoogleReCaptcha,
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3'

import { RECAPTCHA_SITE_KEY } from '~/config'

export type Props = {
  onClick: (arg0: string) => void | Promise<(arg0: string) => void>
  children: (...args: Array<any>) => any
}

export const ReCaptcha = ({ onClick, children }: Props) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const onClickWithReCaptcha = async () => {
    const result = await executeRecaptcha('creditcard')
    onClick(result)
  }

  return children(onClickWithReCaptcha)
}

export const Provider = ({ onClick, children }: Props) => {
  if (!RECAPTCHA_SITE_KEY) return children(() => onClick('test-token'))

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <ReCaptcha onClick={onClick}>{children}</ReCaptcha>
    </GoogleReCaptchaProvider>
  )
}

export default Provider
